// extracted by mini-css-extract-plugin
export default {"autocompleteInput":"AutocompleteWithBubblesNoPlusSign_autocompleteInput__FR1LB"};